import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../features/widget/Widget";
import CalendarWeekDates from "../calendarWidget/calendarWeekDates/CalendarWeekDates";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import ClickStopper from "../../../ui/clickStopper/ClickStopper";
import { monthsAllLang } from "../../../../utils/utils";
import useHebrewDate from "../../../../hooks/useHebrewDate ";
import { hebrewDateType } from "../../../../enums/hebrewDateType";
import classes from "./CalenderWeekWidget.module.css";

const getWeekStart = (date) => {
    const weekStart = new Date(date);
    weekStart.setDate(weekStart.getDate() - weekStart.getDay());
    return weekStart;
};

const getHebrewWeekRange = (weekStartDate, hebrewDate) => {
    const weekEnd = new Date(weekStartDate);
    weekEnd.setDate(weekEnd.getDate() + 6);

    const startMonth = hebrewDate(weekStartDate, hebrewDateType.month);
    const endMonth = hebrewDate(weekEnd, hebrewDateType.month);
    const startYear = hebrewDate(weekStartDate, hebrewDateType.year);
    const endYear = hebrewDate(weekEnd, hebrewDateType.year);

    if (startMonth === endMonth && startYear === endYear) {
        return `${startMonth} ${startYear}`;
    }
    return `${startMonth} ${startYear} - ${endMonth} ${endYear}`;
};

const CalenderWeekWidget = ({ selectedDate, onDateSelect }) => {

    const { lang } = useSelector(state => state.translate);
    const hebrewDate = useHebrewDate();

    const weekStartDate = getWeekStart(selectedDate);
    const gregorianTitle = `${monthsAllLang[selectedDate.getMonth()]?.[lang]} ${selectedDate.getFullYear()}`;
    const hebrewTitle = getHebrewWeekRange(weekStartDate, hebrewDate);

    const handleDateSelect = (e, date) => {
        e.stopPropagation();
        onDateSelect(date);
    };

    const handlePrevWeek = (e) => {
        e.stopPropagation();
        const newDate = new Date(selectedDate);
        newDate.setDate(newDate.getDate() - 7);
        onDateSelect(newDate);
    };

    const handleNextWeek = (e) => {
        e.stopPropagation();
        const newDate = new Date(selectedDate);
        newDate.setDate(newDate.getDate() + 7);
        onDateSelect(newDate);
    };

    return (
        <Widget
            color="#C5D7E4"
            width={360}
            height={155}
            contentScrollable={false}
            className={classes.CalenderWeekWidget}
            onClick={(e) => e.stopPropagation()}
        >
            <div className={classes.WeekWidgetContent}>
                <div className={classes.Header}>
                    <div className={classes.MonthTitles}>
                        <span className={classes.GregorianTitle}>{gregorianTitle}</span>
                        <span className={classes.HebrewTitle}>{hebrewTitle}</span>
                    </div>
                    <div className={classes.Arrows}>
                        <ClickStopper>
                            <button type="button" className={classes.ArrowBtn} onClick={handlePrevWeek} aria-label="previous week">
                                <Icon name={iconsList.back} size="18px" color="#333" />
                            </button>
                        </ClickStopper>
                        <ClickStopper>
                            <button type="button" className={`${classes.ArrowBtn} ${classes.ArrowNext}`} onClick={handleNextWeek} aria-label="next week">
                                <Icon name={iconsList.back} size="18px" color="#333" />
                            </button>
                        </ClickStopper>
                    </div>
                </div>
                <CalendarWeekDates
                    selectedDate={selectedDate}
                    onDateSelect={handleDateSelect}
                    mobile
                />
            </div>
        </Widget>
    );
};

export default CalenderWeekWidget;
